import React, { useEffect, useState } from 'react'
import { Paper, Divider } from '@mui/material';
import { Button } from '@mui/material';
import FormDialog from '../panel/modal';
import AddAlumniForm from '../form/addAlumniForm';
import { useNavigate } from 'react-router-dom';
import ViewStudents from '../table/viewStudents';
import AlumniTable from '../table/viewAlumni';
import Loader from '../panel/loader';

import InputBase from '@mui/material/InputBase';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import DirectionsIcon from '@mui/icons-material/Directions';


import api from '../../API/api';


const AddAlumni = () => {

    const navigation = useNavigate();

    const [rowdata, setRowData] = useState('');
    const [open, setOpen] = React.useState(false);
    const [search, setSearch] = useState('');
    const [load, setLoad] = useState(false)
    const handleClickOpen = (data) => {
        setOpen(true);
        setRowData(data)
        // console.log("aa=>", data);
    };
    const handleClose = () => {
        setOpen(false);
        setRowData('')
    };

    const [data, setdata] = useState([]);
    useEffect(() => {
        getAlumni();
    }, [])

    const handleSearch = (e) => {
        setSearch(e.target.value)
    }

    const getAlumni = () => {
        setLoad(true)
        api.getAlumni(search).then((res) => {
            setLoad(false)
            // console.log("res", res);
            setdata(res.data.data)
            if (res.data.status === 400) {

            }
        })
            .catch((err) => {
                // console.log(err,'saihh');
                setLoad(false)
            })
    }


    return (
        <>
        {load && <Loader />}
            <div className="row">
                <Paper elevation={3}>
                    <div className="col-12 p-2">
                    </div>

                    <div className="col-12 d-flex justify-content-between p-2">
                        <div></div>
                        <Button variant='contained' onClick={handleClickOpen}>+Add Alumni</Button>
                    </div>

                    <FormDialog form={<AddAlumniForm handleClose={handleClose} handleClickOpen={handleClickOpen} rowdata={rowdata} />} title='Add Alumni' open={open} handleClickOpen={handleClickOpen} handleClose={handleClose} />
                </Paper>
            </div>


            <div className="row">
                <Paper>
                    <div className="row">

                        <div className="col-12 p-2 d-flex justify-content-center">

                            <Paper
                                elevation={3}
                                component="form"
                                sx={{ p: '2px 4px', display: 'flex', alignItems: 'center', width: 400 }}
                            >

                                <InputBase
                                    sx={{ ml: 1, flex: 1 }}
                                    placeholder="Registration no/ Batch"
                                    inputProps={{ 'aria-label': 'Registration no/ Batch' }}
                                    name='search'
                                    value={search}
                                    onChange={handleSearch}
                                />
                                <Button type="button" variant='contained' color='success' size='small' aria-label="search" onClick={getAlumni}>
                                    <SearchIcon /> <small> Search </small>
                                </Button>
                                <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />

                            </Paper>


                        </div>


                    </div>
                    {<AlumniTable data={data?.filter(el => el.alumniApprove === 1)} handleClickOpen={handleClickOpen} />}
                </Paper>

            </div>

        </>
    )
}

export default AddAlumni;